<template>
  <div></div>
</template>

<script>
import { useToast } from "vue-toastification";

export default {
  name: "ToastSafariInstallation",
  created() {
    this.toast = useToast();

    this.toast(
      <div style="align-items: center;display: flex;">
        <div class="me-3">
          <i class="bi bi-plus-square-fill" style="font-size: 25px;"></i>
        </div>
        <div>
          To install this webapp on your phone: tap
          <i class="bi bi-box-arrow-down scss-text-blue mx-2 style-download-icon"></i>
          and then add to Home Screen.
        </div>
      </div>,
      {
        timeout: 5000,
        toastClassName: "style-toast",
        closeButtonClassName: "style-toast-close-icon",
      }
    );
  },
};
</script>

<style lang="scss">
.Vue-Toastification__toast--default.style-toast {
  background-color: #f2f2f2;
  font-size: 14px;
  color: $normal-font-color;
  max-width: 90%;
  padding: 20px 20px;
  border-radius: 25px;
}

.Vue-Toastification__close-button.style-toast-close-icon {
  color: $normal-font-color;
}

/* Applied to a wrapper div when using a custom component as content */
.Vue-Toastification__toast-component-body.custom-class-2 {
  width: 100%;
}
.style-download-icon {
  display: inline-block;
  transform: rotate(-180deg);
}
</style>
